<!--  -->
<template>
  <div>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="150px" class="demo-ruleForm">
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="ruleForm.name" v-model.trim="ruleForm.name" style="width:400px" @input="ruleForm.name = ruleForm.name.replace(reg, '')" />
      </el-form-item>
      <el-form-item label="活动文案" prop="copywriting">
        <el-input v-model="ruleForm.copywriting" style="width:400px" />
      </el-form-item>
      <el-form-item label="活动备注" prop="remark">
        <el-input v-model="ruleForm.remark" style="width:400px" />
      </el-form-item>
      <el-form-item label="活动金额" prop="config_id">
        <div class="acrit_box">
          <el-radio-group v-model="ruleForm.config_id">
            <el-radio v-for="element,index in list" :key="index" style="margin-bottom:10px" :label="element.value">{{ element.description }}</el-radio>
          </el-radio-group>
        </div>

      </el-form-item>
      <el-form-item label="限购次数" prop="limited">
        <el-select v-model="ruleForm.limited" placeholder="请选择限购次数">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="期限选择">
        <el-select v-model="time_type" placeholder="请选择">
          <el-option
            v-for="item in timeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="time_type === 2" label="固定天数(活动)" prop="appoint_day">
        <el-input v-model="ruleForm.appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="ruleForm.appoint_day = ruleForm.appoint_day.replace(/[^A-z0-9]/, '')" />
        <!-- <span style="margin-left:10px">结束时间：<span v-if="ruleForm.appoint_day!=''">{{ getNewDay(getdata(), ruleForm.appoint_day) }} 23:59:59</span></span> -->
      </el-form-item>
      <el-form-item v-if="time_type === 2" label="固定天数(弹窗)" prop="pop_appoint_day">
        <el-input v-model="ruleForm.pop_appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="ruleForm.pop_appoint_day = ruleForm.pop_appoint_day.replace(/[^A-z0-9]/, '')" />
        <!-- <span style="margin-left:10px">结束时间：<span v-if="ruleForm.pop_appoint_day!=''">{{ getNewDay(getdata(), ruleForm.pop_appoint_day) }} 23:59:59</span></span> -->
      </el-form-item>
      <el-form-item v-if="time_type === 1" label="活动时间" prop="timearr">
        <el-date-picker
          v-model="ruleForm.timearr"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalue"
        />
      </el-form-item>
      <el-form-item v-if="time_type === 1" label="弹窗时间" prop="tanimearr">
        <el-date-picker
          v-model="ruleForm.tanimearr"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalueone"
        />
      </el-form-item>
      <el-form-item label="活动状态" prop="status">
        <div>
          <el-radio-group v-model="ruleForm.status">
            <el-radio v-for="element,index in optionsr" :key="index" :label="element.value">{{ element.label }}</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item label="落地页显示活动时间" prop="landing_time_status">
        <div>
          <el-radio-group v-model="ruleForm.landing_time_status">
            <el-radio v-for="element,index in optionsrwe" :key="index" :label="element.value">{{ element.label }}</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>

      <el-form-item label="弹窗位置" prop="checkList">
        <el-checkbox-group v-model="ruleForm.checkList" @change="handleCheckedDatesChange">
          <el-checkbox v-for="date in dates" :key="date.key" :label="date.key">{{ date.label }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="弹窗次数" prop="retry">
        <div>
          <el-radio-group v-model="ruleForm.retry">
            <el-radio v-for="element,index in frequencyarr" :key="index" :label="element.value">{{ element.label }}</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>

      <el-form-item label="用户属性" prop="user">
        <div>
          <el-radio-group v-model="ruleForm.user">
            <el-radio v-for="element,index in attributearr" :key="index" :label="element.value">{{ element.label }}</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>

      <el-form-item label="弹窗状态" prop="pop_status">
        <div>
          <el-radio-group v-model="ruleForm.pop_status">
            <el-radio v-for="element,index in popstate" :key="index" :label="element.value">{{ element.label }}</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-top:10px" type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { readingservice, acawraccountlist } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAge = (rule, value, callback) => {
      console.log(this.ruleForm.timearr[0])
      console.log(this.ruleForm.timearr[1])
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.timearr[0] == this.ruleForm.timearr[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    var checkAger = (rule, value, callback) => {
      console.log(this.ruleForm.tanimearr[0])
      console.log(this.ruleForm.tanimearr[1])
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.tanimearr[0] == this.ruleForm.tanimearr[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    var checkAgernum = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAgerall = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.pop_appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }

    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      ruleForm: {
        name: '',
        copywriting: '',
        remark: '',
        config_id: '',
        limited: '',
        timearr: [],
        tanimearr: [],
        status: 1,
        landing_time_status: 1,
        checkList: [],
        retry: 0,
        user: 0,
        pop_status: 1,
        appoint_day: '',
        pop_appoint_day: ''
      },
      starttime: '',
      endtime: '',
      popstarttime: '',
      popendtime: '',
      list: [],
      options: [{
        value: '不限',
        label: '不限'
      }, {
        value: '1',
        label: '1'
      }, {
        value: '2',
        label: '2'
      }, {
        value: '3',
        label: '3'
      }],
      optionsr: [{
        value: 1,
        label: '正常'
      }, {
        value: 0,
        label: '隐藏'
      }],
      optionsrwe: [
        {
          value: 1,
          label: '正常'
        }, {
          value: 0,
          label: '隐藏'
        }
      ],
      frequencyarr: [
        {
          value: 0,
          label: '每次'
        }, {
          value: 1,
          label: '只弹一次'
        }, {
          value: 2,
          label: '每日1次'
        }
      ],
      attributearr: [
        {
          value: 0,
          label: '所有'
        }, {
          value: 1,
          label: '已支付'
        }, {
          value: 2,
          label: '未支付'
        }
      ],
      dates: [
        {
          key: 0,
          label: '最近阅读'
        }, {
          key: 1,
          label: '男生主页'
        },
        {
          key: 2,
          label: '女生主页'
        },
        {
          key: 3,
          label: '个人中心'
        },
        {
          key: 4,
          label: '书城'
        },
        {
          key: 5,
          label: '免费'
        }
      ],
      popstate: [
        {
          value: 1,
          label: '正常'
        }, {
          value: 0,
          label: '隐藏'
        }
      ],
      obj: {},
      arr: [],
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2,
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        copywriting: [
          { required: true, message: '请输入活动文案', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入活动备注', trigger: 'blur' }
        ],
        config_id: [
          { required: true, message: '请选择活动金额', trigger: 'change' }
        ],
        limited: [
          { required: true, message: '请选择限购次数', trigger: 'change' }
        ],
        checkList: [
          { type: 'array', required: true, message: '请至少选择一个弹窗位置', trigger: 'change' }
        ],
        timearr: [
          { type: 'array', required: true, message: '请选择时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        tanimearr: [
          { type: 'array', required: true, message: '请选择时间', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数(活动)', trigger: 'change' },
          { validator: checkAgernum, trigger: 'change' }
        ],
        pop_appoint_day: [
          { required: true, message: '请输入固定天数(弹窗)', trigger: 'change' },
          { validator: checkAgerall, trigger: 'change' }
        ]

      }
    }
  },
  created() {
    this.getlistr()
  },
  mounted() {

  },
  methods: {
    async getlistr() {
      const data = await acawraccountlist({
        platformId: this.platformid,
        activityType: 1
      })
      this.list = data.data.programme
      console.log('data', data)
    },
    datavalue(val) {
      console.log('val', val)
      this.starttime = val[0]
      this.endtime = val[1]
    },
    datavalueone(val) {
      console.log('val', val)
      this.popstarttime = val[0]
      this.popendtime = val[1]
    },
    handleCheckedDatesChange(val) {
      // this.obj = {}
      // for (let i = 0; i < val.length; i++) {
      //   this.obj[`${val[i]}`] = `on`
      // }
    },
    submitForm(formName) {
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate((valid) => {
        const par = {}
        if (this.time_type === 1) {
          par.time_type = this.time_type
          par.start_time = this.starttime
          par.end_time = this.endtime
        } else {
          par.time_type = this.time_type
          par.appoint_day = Number(this.ruleForm.appoint_day)
        }
        const pop = {}
        if (this.time_type === 1) {
          pop.popstarttime = this.popstarttime
          pop.popendtime = this.popendtime
        } else {
          pop.pop_appoint_day = Number(this.ruleForm.pop_appoint_day)
        }
        if (valid) {
          // eslint-disable-next-line eqeqeq
          // if (JSON.stringify(this.obj) === '{}') {
          if (this.ruleForm.checkList.length === 0) {
            console.log('没选')
            readingservice({
              ...par,
              platform_id: this.platformid,
              activity_type: 1,
              activity_info: {
                ...pop,
                name: this.ruleForm.name,
                copywriting: this.ruleForm.copywriting,
                remark: this.ruleForm.remark,
                config_id: this.ruleForm.config_id,
                limited: this.ruleForm.limited,
                // starttime: this.starttime,
                // endtime: this.endtime,
                // popstarttime: this.popstarttime,
                // popendtime: this.popendtime,
                status: this.ruleForm.status,
                landing_time_status: this.ruleForm.landing_time_status,
                pop_status: this.ruleForm.pop_status,
                retry: this.ruleForm.retry,
                user: this.ruleForm.user
                // row: {

                // },
                // extra: {
                //   pop: {
                //     retry: this.ruleForm.retry,
                //     user: this.ruleForm.user
                //   }
                // }
              }
            }).then((res) => {
              this.$message({
                type: 'success',
                message: '添加成功!'
              })
              this.$emit('close')
            })
          } else {
            readingservice({
              ...par,
              platform_id: this.platformid,
              activity_type: 1,
              activity_info: {
                ...pop,
                name: this.ruleForm.name,
                copywriting: this.ruleForm.copywriting,
                remark: this.ruleForm.remark,
                config_id: this.ruleForm.config_id,
                limited: this.ruleForm.limited,
                // starttime: this.starttime,
                // endtime: this.endtime,
                // popstarttime: this.popstarttime,
                // popendtime: this.popendtime,
                status: this.ruleForm.status,
                landing_time_status: this.ruleForm.landing_time_status,
                pop_status: this.ruleForm.pop_status,
                retry: this.ruleForm.retry,
                user: this.ruleForm.user,
                position: this.ruleForm.checkList.toString()
                // position: this.obj
                // row: {

                // },
                // extra: {
                //   pop: {
                //     retry: this.ruleForm.retry,
                //     user: this.ruleForm.user,
                //     position: this.obj
                //   }
                // }
              }
            }).then((res) => {
              this.$message({
                type: 'success',
                message: '添加成功!'
              })
              this.$emit('close')
            })
          }
        } else {
          console.log('error submit!!')
          // console.log(...this.obj)
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.acrit_box{
  height: 150px;
  overflow: hidden;
  overflow-y: scroll;
}
</style>
